import React from "react";
import { Card, Statistic } from "antd";

interface KpiCardProps {
  title: string;
  value: string | number;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  color?: string;
  icon?: React.ReactNode;
}

export default function KpiCard({ title, value, prefix, suffix, color, icon }: KpiCardProps) {
  return (
    <Card bordered={false} style={{ height: "100%" }}>
      <Statistic
        title={<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{icon}{title}</div>}
        value={value}
        valueStyle={{ color: color }}
        prefix={prefix}
        suffix={suffix}
      />
    </Card>
  );
}
